import React, { useEffect, useState } from "react";

function SideBarNavigation({ num, sectionOffsets }) {
  const [selected, isSelected] = useState(1);
  const offsetList = sectionOffsets;

  const scrollToSection = (i) => {
    const section = document.getElementById(i);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      isSelected(i);
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      offsetList.forEach((offset, index) => {
        if (window.pageYOffset > offset - 100) {
          isSelected(index + 1);
          console.log(window.pageYOffset);

          console.log(offset - 100);
        }
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offsetList]);

  return (
    <aside className="fixed top-1/2 z-50 -translate-y-1/2 right-5 p-4 bg-gray-500 flex flex-col gap-2">
      {[...Array(num)].map((_, index) => (
        <button
          key={index}
          className={`rounded-full w-4 h-4 text-sm font-semibold transition-all duration-300 shadow-sm bg-gray-300 text-slate-700 outline-none hover:bg-secundario ${selected === index + 1 ? "bg-secundario/80 outline outline-2 outline-secundario/50" : ""}`}
          onClick={() => scrollToSection(index + 1)}
        ></button>
      ))}
    </aside>
  );
}

export default SideBarNavigation;
